import { VariantCharacters } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantCharacters.tsx';
import { VariantIcon } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantIcon.tsx';
import { VariantPoint } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantPoint.tsx';
import { VariantStar } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantStar.tsx';
import { VariantSizes } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/shared/variantUtils';
import { VariantWrapText } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/shared/VariantWrapText.tsx';
import styled, { CSSProperties } from 'styled-components';

interface VIIconProps {
    color: string;
    highlighted: boolean;
    title: string;
    size: VariantSizes;
    icon: string;
    sublabel?: string;
    style?: CSSProperties;
    className?: string;
}

export const VIIcon = (props: VIIconProps) => {
    return (
        <S_VIIcon className={props.className} style={props.style}>
            <S_WrapIcon>
                {props.size === 1 && (
                    <>
                        {!props.sublabel && <VariantPoint color={props.color} />}
                        {props.sublabel && <VariantCharacters characters={props.sublabel} />}
                    </>
                )}
                {(props.size === 2 || props.size === 3) && (
                    <>
                        {!props.sublabel && <VariantIcon color={props.color} icon={props.icon} />}
                        {props.sublabel && <VariantCharacters characters={props.sublabel} />}
                        {props.highlighted && <S_VariantStar />}
                    </>
                )}
            </S_WrapIcon>
            {props.size === 3 && (
                <S_VariantWrapText
                    top={props.sublabel ? 28 : 28}
                    variantText={{ text: props.title }}
                />
            )}
        </S_VIIcon>
    );
};

const S_VIIcon = styled.div`
    display: flex;
    flex-direction: column;
    width: fit-content;
    position: relative;
    width: 30px;
    height: 30px;
    justify-content: center;
    align-items: center;
    user-select: none;
`;

const S_WrapIcon = styled.div`
    position: relative;
    z-index: 1;
`;

const S_VariantStar = styled(VariantStar)`
    position: absolute;
    top: -7px;
    right: -7px;
`;

const S_VariantWrapText = styled(VariantWrapText)`
    z-index: 2;
`;
